export default {
    nav:draw_nav
}
function draw_nav(data,getModelDom){
    var infoList = data.infoList
    var getSubModelListDom = function(content){
        let html = ''
        content.forEach(function(model){
            html += getModelDom(model)
        })
        return html
    }
    return `
        <section class="nav-model nav-model-1">
            <ul class="nav-list">
                ${infoList.map(function(item,index){
                    return `<li class="nav-item ${index == 0 ? 'cur' : ''}" data-cateid="${item.cateid}" data-tag="${item.tag}"><span>${item.title}</span></li>`
                })}
            </ul>
            <div class="rightContainer">
                ${infoList.map(function (item, index) {
                    return `<div class="subModelList">${getSubModelListDom(item.content)}</div>`
                }).join('')}
            </div>
        </section>
        
    `
}